import { render } from "./field.vue?vue&type=template&id=0d2b7dd0"
import script from "./field.vue?vue&type=script&lang=js"
export * from "./field.vue?vue&type=script&lang=js"

import "./field.vue?vue&type=style&index=0&id=0d2b7dd0&lang=scss"

import exportComponent from "/opt/compla/docker/sites/my-atw-global/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__